"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BorderTypes = void 0;
let BorderTypes = exports.BorderTypes = /*#__PURE__*/function (BorderTypes) {
  BorderTypes["Dashed"] = "dashed";
  BorderTypes["Solid"] = "solid";
  return BorderTypes;
}({});
function getBordersStyles(size, type, bgColor) {
  if (type === BorderTypes.Dashed) {
    return "\n      background-image: repeating-linear-gradient(0deg, ".concat(bgColor, ", ").concat(bgColor, " 10px, transparent 10px, transparent 18px, ").concat(bgColor, " 18px), repeating-linear-gradient(90deg, ").concat(bgColor, ", ").concat(bgColor, " 10px, transparent 10px, transparent 18px, ").concat(bgColor, " 18px), repeating-linear-gradient(180deg, ").concat(bgColor, ", ").concat(bgColor, " 10px, transparent 10px, transparent 18px, ").concat(bgColor, " 18px), repeating-linear-gradient(270deg, ").concat(bgColor, ", ").concat(bgColor, " 10px, transparent 10px, transparent 18px, ").concat(bgColor, " 18px);\n      background-size: ").concat(size, "px 100%, 100% ").concat(size, "px, ").concat(size, "px 100% , 100% ").concat(size, "px;\n      background-position: 0 0, 0 0, 100% 0, 0 100%;\n      background-repeat: no-repeat;  \n    ");
  }
  return "border: ".concat(size, "px solid ").concat(bgColor, ";");
}
var _default = exports.default = getBordersStyles;